import { Box, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

const forwardFill = { shouldForwardProp: (prop: PropertyKey) => prop !== 'fill' }

export const EmptyStateFrame = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1),
  borderRadius: 4,
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
}))

export const FormRoot = styled(
  Box,
  forwardFill,
)<{ fill?: boolean }>(({ fill }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  ...(fill && { flex: 1, height: '100%' }),
}))

export const WorkspaceGrid = styled(
  Box,
  forwardFill,
)<{ fill?: boolean }>(({ theme, fill }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  borderTop: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  minHeight: 0,
  ...(fill ? { flex: 1 } : { height: 'auto' }),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'minmax(0, 1fr) 380px',
    ...(!fill && { height: 640 }),
  },
}))
